import React, { useEffect } from 'react';
import { ITicket } from '../../../../types/Ticket/ITicket';
import { Form, FormElement, Field } from '@progress/kendo-react-form';
import { PanelBarItem, PanelBar } from '@progress/kendo-react-layout';
import CustomFormControl from '../../../CustomForms/CustomForm';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { RevUserContext, RevUserContextType } from '../../../../context/UserContext';
import { Button } from '@progress/kendo-react-buttons';
import { useReduxDispatch, useReduxSelector } from '../../../../redux/hooks';
import { setField, setForm } from '../../../../slices/TicketDetailSlice';
import { toast } from 'react-toastify';
import { PartialSpinny } from '../../../Nav/Spinny';

interface CustomFormProps extends ITicket {
    showSaveButton?: boolean;
}

const CustomForm: React.FC<CustomFormProps> = (ticket) => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const { data: ticketForm } = TicketApi.useGetTicketFormQuery(ticket?.ID, { skip: !(ticket.CustomFormId > 0) });
    const [updateFormFields, { isLoading: isUpdating }] = TicketApi.useUpdateTicketFormMutation();
    const SECTION_REQUIRED = "section-required";
    const apiError = '';
    const { form: stateFields } = useReduxSelector(state => state.ticketDetails);
    const dispatch = useReduxDispatch();

    //Put the form fields into the state slice
    useEffect(() => {
        if (ticketForm) {
            dispatch(setForm(ticketForm));
        }
    }, [ticketForm, dispatch]);

    const fieldChanged = (e) => {
        console.log('fieldChanged', e)
        //update the Ticket details Slice with the new field value
        dispatch(setField(e.value))
    };
    const handleFormSubmit = () => {
        updateFormFields({ ticketId: ticket.ID, formId: ticket.CustomFormId, fields: stateFields?.Fields }).unwrap().then(() => {
            toast.success('Form saved successfully.')
        }).catch((e) => {
            console.error(e);
            toast.error('Error saving form. Status:' + (e.status ?? '(unknown)') + ' Message:' + (e.data ?? '(empty)'))
        });
    };
    const customFormTop = true;
    //INternal users OR external users IF the form is setup to show on the external interface
    const userHasAccess = (ticketForm?.View_External && profile?.Features.External_Interface) || !profile?.Features.External_Interface;

    if (stateFields == null || !profile?.Features.Custom_Fields) return <></>;


    return (
        ticket.CustomFormId > 0 && userHasAccess
            ?
            <div className="mt-3 pop">
                <Form ignoreModified={true} onSubmit={handleFormSubmit} id='custom-form' render={(formRenderProps) =>
                    <FormElement>
                        <div id='error-summary'>
                            {/* Validation */}
                            {formRenderProps.errors &&
                                formRenderProps.errors.VALIDATION_SUMMARY && (
                                    <div className={"k-messagebox k-messagebox-error"}>
                                        {formRenderProps.errors.VALIDATION_SUMMARY}
                                    </div>
                                )}
                            {apiError && <div className={"k-messagebox k-messagebox-error"}>
                                {apiError}
                            </div>}
                        </div>
                        <PanelBar expanded={["form"]}>
                            <PanelBarItem id="form" title={ticket?.CustomFormName + (formRenderProps.errors.customform ? ' - ' + formRenderProps.errors.customform : '')} className={customFormTop ? formRenderProps.errors.customform ? SECTION_REQUIRED : null : 'hidden'} icon='paste-plain-text'>
                                {isUpdating && <PartialSpinny />}
                                {<Field
                                    id={"customform"}
                                    name={"customform"}
                                    label={"form"}
                                    component={CustomFormControl}
                                    form={ticketForm}
                                    fields={stateFields.Fields}
                                    companyId={ticket.Company_Id}
                                    onChange={fieldChanged} />}

                                {ticket.showSaveButton !== false && <div className='ms-auto p-1 d-flex flex-row-reverse' >
                                    <Button form='custom-form' type={"submit"} style={{ width: '150px', color: '#fff', background: profile?.Nav_Hex_Color }}>
                                        <img src='./images/Log-Ticket-White.png' className='inline mr-2 w-5' />
                                        Save
                                    </Button>
                                </div>}
                            </PanelBarItem>
                        </PanelBar>
                    </FormElement>} />
            </div>
            : <></>
    );

};

export default CustomForm;